const debounce = (id = 0) => (cb, { time = 900 } = {}) => {
  clearTimeout(id);
  console.log('called', id)
  id = setTimeout(() => {
    console.log('inside timeout', id)
    cb();
  }, time);
};

export const Debounce = debounce();